import * as Yup from "yup";
import { ContraparteGrupoStatus } from "./model";

export class ContraparteGrupoSchema {
  public static id() {
    return Yup
      .number()
      .positive("Id deve ser um numero positivo");
  }

  public static record() {
    return Yup
      .object()
      .shape(recordShape);
  }

  public static createForm() {
    const {
      nome,
      status,
      contrapartes,
    } = recordShape;

    const createFormShape = {
      nome,
      status,
      contrapartes,
    };

    return Yup
      .object()
      .shape(createFormShape);
  }

  public static updateForm() {
    const {
      nome,
      status,
      contrapartes,
    } = recordShape;

    const updateFormShape = {
      nome,
      status,
      contrapartes,
    };

    return Yup
      .object()
      .shape(updateFormShape);
  }
}

const contrapartesAddShape = {
  id: Yup
    .number()
    .required("Campo é obrigatório"),
};

const recordShape = {
  nome: Yup
    .string()
    .max(32, "Nome deve conter no máximo 32 caracteres")
    .required("Nome é obrigatório"),
  status: Yup
    .string()
    .oneOf(Object.values(ContraparteGrupoStatus))
    .required("Situação é obrigatório"),
  contrapartes: Yup
    .array()
    .of(Yup.object().shape(contrapartesAddShape))
    .optional(),
};
